import styled from "styled-components";

export const ContentParentStyled = styled.div`
  padding: 50px;
`;